import PlayerTransactionsCard from './PlayerTransactionsCard.svelte';

!customElements.get('player-transactions-card') && customElements.define('player-transactions-card', PlayerTransactionsCard);
export default PlayerTransactionsCard;
